import { AccountVerificationWrapper } from './AccountVerification.styles';
import { useGlobalState } from '@/hooks';

const AccountVerification: React.FC = () => {
  const { userInfo } = useGlobalState();
  return <AccountVerificationWrapper>{userInfo?.email}</AccountVerificationWrapper>;
};

export default AccountVerification;
